import { withStyles } from '@mui/styles';

import Typography from '@mui/material/Typography';

export const colors = {
  // Ashthorn Brand Colors
  primaryColor: '#4F5F4B', // Moss Green
  primaryAccent: '#3d4a3a', // Moss Green (dark)
  primaryHighlight: '#6b7d67', // Moss Green (light)
  primaryLighter: '#8a9d87', // Moss Green (pale)
  primaryDarker: '#2F2B28', // Deep Bark
  primaryText: '#FDFAF6', // Warm White
  primaryTextAccent: '#6A6E72', // River Slate
  primaryTextHighlight: '#FDFAF6', // Warm White
  secondaryColor: '#8A6F45', // Weathered Bronze
  secondaryAccent: '#6e5837', // Weathered Bronze (dark)
  gold: '#8A6F45', // Weathered Bronze (flat)
  goldAccent: '#6e5837', // Weathered Bronze (dark)
  goldHighlight: '#a3865a', // Weathered Bronze (light)
  darkAccent: '#2F2B28', // Deep Bark
  highlightBright: '#EFE9E1', // Stone Linen
  highlightMedium: '#BFA58A', // Soft Clay
  highlightDark: '#6A6E72', // River Slate
  highlightDarker: '#4F5F4B', // Moss Green
  successGreen: '#008000',
  errorRed: '#dc3636',
  white: '#FDFAF6', // Warm White
  lightGrey: '#EFE9E1', // Stone Linen
  black: '#2F2B28', // Deep Bark
  blackOpacity: 'rgba(47, 43, 40, 0.3)', // Deep Bark 30%
  microsoftBlue: '#00a2ed',
  googleRed: '#de5246',
};

export const formButton = {
  margin: '5px',
};

export const goldButtonStyling = {
  background: colors.gold,
  color: colors.white,
  '&:hover': {
    background: colors.goldHighlight,
    color: colors.white,
  },
};

export const MutedTypography = withStyles(() => ({
  root: {
    display: 'contents',
    color: colors.primaryTextAccent,
    fontFamily: 'Cormorant Garamond, Georgia, Times New Roman, serif',
    marginTop: '20px',
    marginBottom: '20px',
  },
}))(Typography);
